/* tslint:disable:jsx-no-lambda no-empty*/
import { Banner, Button, ColumnDefinition, Icon, PagingControl, Table } from '@abb/common-ux';
import { Search } from '@module/shared';
import { defaultSite, IPagingSettings, ISiteModel, ISitesState, ISortingSettings } from '@module/shared/components/Site/models';
import { SERVIS_SEARCH_PLACEHOLDER } from '@service/constants';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as ActionCreators from '../actionCreators/registerSiteActionCreators';
import Sites from './Sites';

export class RegisterSitesContainer extends React.Component<any, any> {
  public render() {
    let errorMessage;
    if (this.props.siteRegister.attempt && this.props.siteRegister.success) {
      this.props.history.push(`/Licenses/${this.props.siteRegister.siteId}`);
    } else if (this.props.siteRegister.attempt && !this.props.siteRegister.success) {
      errorMessage = <div className='row'> <Banner bannerType='error' id='errorBanner' onRemove={banner => { }}>Error</Banner><br /><br /></div>;
    }

    const SiteTableColumn = ColumnDefinition as new () => ColumnDefinition<ISiteModel>;
    return (
      <div className='container'>
        <div>
          <h3>ServIS Sites</h3>
        </div>
        <div className='row'>
          <div className='col-sm-4'>
            <Search filter={this.props.searchFilter} applyFilter={this.props.applyFilter} clearFilter={this.props.clearFilter} changeFilterField={this.props.changeFilterField} placeholder={SERVIS_SEARCH_PLACEHOLDER}/>
          </div>
          <div className='col-sm-6 col-sm-offset-2 text-right'>
            <Button buttonType='primary' buttonSize='default' disabled={!this.props.siteSelected || this.props.registeredSiteSelected} onClick={() => this.props.registerSite()}>Register Site</Button>
            <PagingControl totalItemCount={this.props.totalNumberOfSites} top={this.props.pagingSettings.pageSize} skip={this.props.pagingSettings.skipItems} pageRequested={this.props.requestPage} />
          </div>
        </div>
        {errorMessage}
        <div className='row'>
          <div className='col-md-12'>
            <Sites sites={this.props.sites} sortingSettings={this.props.sortingSettings} history={this.props.history} sortField={this.props.sortField} onCheck={this.props.checkboxSelected} siteSelected={this.props.siteSelected} selectedSite={this.props.selectedSite} searchFilter={this.props.searchFilter} sitesLoading={this.props.sitesLoading} />
          </div>
        </div>
      </div>
    );
  }

  componentDidMount() {
    this.props.requestSitesGet(this.props.pagingSettings, this.props.sortingSettings, this.props.searchFilter, this.props.fromServIs);
  }

  componentWillUnmount() {
    this.props.dispatchLeavingPage();
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(RegisterSitesContainer) as any);

export function mapStateToProps(store: { registerState: any; userState: { loggedInUser: { access_token: string } } }) {
  const { access_token: accessToken } = store.userState.loggedInUser;
  return { ...store.registerState, accessToken };
}

function mapDispatchToProps(dispatch: any) {
  return {
    requestSitesGet: (pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, searchFilter: string, fromServIs: boolean, accessToken: string) =>
      dispatch(ActionCreators.onSiteGetRequest(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken)),
    registerSite: (selectedSite: ISiteModel, accessToken: string) =>
      dispatch(ActionCreators.onRegisterSite(selectedSite, accessToken)),
    dispatchPagingChange: (pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, searchFilter: string, fromServIs: boolean, accessToken: string) =>
      dispatch(ActionCreators.onPagingChange(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken)),
    dispatchSortingChange: (pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, searchFilter: string, fromServIs: boolean, accessToken: string) =>
      dispatch(ActionCreators.onSortingChange(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken)),
    dispatchApplyFilter: (searchFilter: string, pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, fromServIs: boolean, accessToken: string) =>
      dispatch(ActionCreators.onFilterApplied(searchFilter, pagingSettings, sortingSettings, fromServIs, accessToken)),
    dispatchFilterFieldChange: (searchFilter: string) =>
      dispatch(ActionCreators.onFilterFieldChange(searchFilter)),
    dispatchCheckboxSelected: (siteIsSelected: boolean, selectedSite: ISiteModel) =>
      dispatch(ActionCreators.onSiteSelected(siteIsSelected, selectedSite)),
    dispatchLeavingPage: () =>
      dispatch(ActionCreators.onRegisterPageLeave())
  };
}

function mergeProps({accessToken, ...propsFromState}: any, propsFromDispatch: any, ownProps: any) {
  return {
    ...propsFromState,
    ...ownProps,
    requestSitesGet: (pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, searchFilter: string, fromServIs: boolean) =>
      propsFromDispatch.requestSitesGet(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken),
    requestPage: (skipItems: number) => {
      const newPagingSettings = { ...propsFromState.pagingSettings, skipItems };
      propsFromDispatch.dispatchPagingChange(newPagingSettings, propsFromState.sortingSettings, propsFromState.searchFilter, propsFromState.fromServIs, accessToken);
    },
    sortField: (sortField: string) => {
      let newSortingSettings = null;
      if (sortField === propsFromState.sortingSettings.sortField) {
        const newDirection = propsFromState.sortingSettings.sortDirection === 'asc' ? 'desc' : 'asc';
        newSortingSettings = { ...propsFromState.sortingSettings, sortDirection: newDirection };
      } else {
        newSortingSettings = { sortField, sortDirection: 'asc' };
      }
      propsFromDispatch.dispatchSortingChange(propsFromState.pagingSettings, newSortingSettings, propsFromState.searchFilter, propsFromState.fromServIs, accessToken);
    },
    applyFilter: (event: any) => {
      event.preventDefault();
      propsFromDispatch.dispatchApplyFilter(propsFromState.searchFilter, propsFromState.pagingSettings, propsFromState.sortingSettings, propsFromState.fromServIs, accessToken);
    },
    clearFilter: () => propsFromDispatch.dispatchApplyFilter('', propsFromState.pagingSettings, propsFromState.sortingSettings, propsFromState.fromServIs, accessToken),
    changeFilterField: (event: React.ChangeEvent<any>) => {
      propsFromDispatch.dispatchFilterFieldChange(event.target.value);
    },
    checkboxSelected: (selectedSite: ISiteModel) => {
      const siteIsSelected = !propsFromState.siteSelected || (propsFromState.selectedSite.servIsId !== selectedSite.servIsId);
      selectedSite = siteIsSelected ? selectedSite : defaultSite;
      propsFromDispatch.dispatchCheckboxSelected(siteIsSelected, selectedSite);
      },
    registerSite: () => propsFromDispatch.registerSite(propsFromState.selectedSite, accessToken),
    dispatchLeavingPage: () => propsFromDispatch.dispatchLeavingPage()
  };
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/modules/registerSite/components/SitesContainer.tsx